import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'ConfirmLink',
  data: function () {
    return {
      message: 'Please wait a moment ...',
    }
  },
  methods: {
    login() {
      this.$router.push('/login');
    },
    confirmLink(code) {
      if (!code || code == '') {
        this.message = 'Wrong code provided';
        setTimeout(() => {
          this.login();
        }, 5000);
      }
      else {
        axios.post('/account/ActivateAccount', { Value: code })
          .then(response => {
            if (response.data.data.status == 0) {
              this.message = 'Email address confirmed, you will be redirected to login page in a moment.';
              setTimeout(() => {
                this.login();
              }, 3000);
            }
            else
              this.message = response.data.data.text;
          })
          .catch(e => {
            console.log(e);
            this.message = e.Message;
          })
      }
    },
  },
  created() {
    var code = this.$route.params.code;
    this.confirmLink(code);
  }
}
